import { render, staticRenderFns } from "./CustomPageForm.vue?vue&type=template&id=1f071bb8&scoped=true&"
import script from "./CustomPageForm.vue?vue&type=script&lang=js&"
export * from "./CustomPageForm.vue?vue&type=script&lang=js&"
import style0 from "./CustomPageForm.vue?vue&type=style&index=0&id=1f071bb8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f071bb8",
  null
  
)

export default component.exports